var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useWatch } from 'react-hook-form';
import { Button } from 'shared/components';
export var IssueActions = function (_a) {
    var disclosure = _a.disclosure, isLoading = _a.isLoading;
    var canSubmitIssue = true;
    var reason = useWatch({ name: 'issueReason' });
    if (!reason) {
        return _jsx(_Fragment, {});
    }
    return (_jsxs(_Fragment, { children: [_jsx(Button, __assign({ variant: "secondary", onClick: disclosure.onClose, flexBasis: 1, flexGrow: 1 }, { children: "Cancel" })), _jsx(Button, __assign({ "data-testid": "submitIssueContents", variant: "redLinks", disabled: !canSubmitIssue, type: "submit", flexBasis: 1, flexGrow: 1, isLoading: isLoading }, { children: "Delete note" }))] }));
};
